'use client'
import { HomeLanding } from '@/components/organisms/home/HomeLanding'
import { ROUTES } from '@/config/routes'
import { useAuthStore } from '@/features/auth'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function Index() {
	const { isAuthenticated, isLoading, isHydrated, onboardingCompleted } = useAuthStore()
	const router = useRouter()

	useEffect(() => {
		if (!isHydrated || isLoading) {
			return
		}
		if (isAuthenticated) {
			router.push(onboardingCompleted ? ROUTES.DASHBOARD : ROUTES.ONBOARDING)
		}
	}, [isAuthenticated, isLoading, isHydrated, onboardingCompleted, router])

	if (!isHydrated || isLoading) {
		return (
			<div className="flex min-h-dvh items-center justify-center bg-white">
				<div className="h-10 w-10 animate-spin rounded-full border-b-2 border-(--brand-primary)" />
			</div>
		)
	}

	if (isAuthenticated) {
		return null
	}

	return <HomeLanding />
}
